import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ConfigService } from "../../common/service/config.service";
import { NgIf } from "@angular/common";

@Component({
  selector: 'content-block',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './content-block.component.html'
})
export class ContentBlockComponent implements OnInit {

  public config: any;
  @Input() slug: string = '';

  constructor(
    private configService: ConfigService,
  ) {}

  ngOnInit(): void {
    // console.log('content-block', this.config);
    this.configService.config$.subscribe((config) => {
      this.config = config;
    });
  }


  hasContentBlock(slug: string): boolean {
    // console.log('hasContentBlock', slug, this.config);
    if(this.config && this.config.contentBlocks) {
      return this.config.contentBlocks[slug] !== undefined && this.config.contentBlocks[slug] !== '';
    }
    return false;
  }

  getContentBlock(slug: string): { content: string, type: string } {
    // console.log('getContentBlock', slug, this.config);
    if(this.config && this.config.contentBlocks) {
      return this.config.contentBlocks[slug];
    }
    return { content: '', type: '' };
  }
}
